module.exports = __webpack_public_path__ + "img/bg_loading_small.e53c9700.png";